import type { InvestorHomeData, MyInvestmentData } from "@/domain/investor";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

async function getJson<T>(path: string): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`);
  const body = await response.json();
  if (!response.ok || body.status === "error") {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
  return body.data as T;
}

export function fetchInvestorHome(investorId = "INV-0002") {
  return getJson<InvestorHomeData>(`/api/investor/home?investorId=${investorId}`);
}

export function fetchMyInvestment(investorId = "INV-0002") {
  return getJson<MyInvestmentData>(`/api/investor/my-investment?investorId=${investorId}`);
}
